/* 🤖 this file was generated by svg-to-ts */
export const mgcIconArrowLeftRegular: {
  name: 'arrow-left-regular';
  data: string;
} = {
  name: 'arrow-left-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.58 5.439c-.231.115-6.076 5.97-6.158 6.17-.089.213-.08.608.017.808.053.11 1.062 1.145 3.07 3.15 3.323 3.318 3.072 3.104 3.595 3.063a.96.96 0 0 0 .788-.53c.113-.211.119-.656.013-.86-.04-.077-.993-1.062-2.119-2.19L6.74 13h6.683c5.866 0 6.708-.007 6.887-.061.378-.112.69-.537.69-.939s-.312-.827-.69-.939c-.179-.054-1.021-.061-6.887-.061H6.74l2.046-2.05c1.126-1.128 2.079-2.113 2.119-2.19.107-.205.1-.649-.014-.864-.1-.19-.328-.402-.517-.481-.198-.083-.603-.07-.794.024"/></svg>`
};
